import styled from "@emotion/styled";

import { Icon } from "metabase/core/components/Icon";
import { color } from "metabase/lib/colors";

export const JoinStrategyIcon = styled(Icon)`
  color: ${color("brand")};
`;
